import React, { useEffect, useState } from "react";
import { useQRCodeScan } from "../hooks/useQrScanner";
import { Redirect } from "react-router-dom";
import { useQuery } from "../hooks/useQuery";
import { authUserWithScan } from "../hooks/apiCalls";

const Scanner = (props) => {
  let query = useQuery();
  const [camera, setCameras] = useState([]);
  const { startQrCode, decodedQRData, stopQrCode } = useQRCodeScan({
    qrcodeMountNodeID: "reader",
    // closeAfterScan: false
  });

  useEffect(() => {
    if (query.get("userAuth")) {
      if (query.get("scanned")) {
        props.history.push("/progress?userAuth=" + query.get("userAuth"));
      } else {
        console.log("qr code start scanning");
        startQrCode();
      }
    }
    // getCameras()
  }, []);

  useEffect(() => {
    if (decodedQRData.data) {
      let response = authUserWithScan({
        qr_code: decodedQRData.data,
        bearerToken: query.get("userAuth"),
      });
      Promise.all([response]).then((data) => {
        if (data[0].status !== 200) {
          //error
          startQrCode();
        } else {
          console.log(data[0]);
          props.history.push("/progress?userAuth=" + query.get("userAuth"));
          //success
        }
      });
    }
  }, [decodedQRData]);

  // const getCameras = () => {
  //     let cameraId
  //     Html5Qrcode.getCameras().then(devices => {
  //         setCameras(devices)
  //         console.log(devices)
  //         /**
  //          * devices would be an array of objects of type:
  //          * { id: "id", label: "label" }
  //          */
  //         if (devices && devices.length) {
  //             cameraId = devices[0].id;
  //             // .. use this to start scanning.
  //         }
  //     }).catch(err => {
  //         // handle err
  //     });

  //     const html5QrCode = new Html5Qrcode(/* element id */ "reader");
  //     html5QrCode.start(
  //         cameraId,
  //         {
  //             fps: 10,    // Optional, frame per seconds for qr code scanning
  //             qrbox: { width: 250, height: 250 }  // Optional, if you want bounded box UI
  //         },
  //         (decodedText, decodedResult) => {
  //             // do something when code is read
  //         },
  //         (errorMessage) => {
  //             // parse error, ignore it.
  //         })
  //         .catch((err) => {
  //             // Start failed, handle it.
  //         });
  // }

  return (
    <div className="pt-[15px]">
      {query.get("userAuth") ? (
        <div id="reader" width="600px" height="100%"></div>
      ) : (
        <div class="w-full flex justify-center items-center min-h-screen">
          <p>something went wrong</p>
        </div>
      )}
      {/* <p>{decodedQRData}</p> */}
    </div>
  );
};

export default Scanner;
